import React, { useEffect } from "react";
import styles from "./TrendingJobs.module.scss";
import NO_IMAGE from "../../images/NO_IMAGE.jpg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjects } from "../../reducer/projectsSlice";
import { serverFiles } from "utils/utils";
import QreativesLogoSVG from "components/SVGComponents/QreativesLogoSVG";
import TrendingJobsSkeleton from "./TrendingJobsSkeleton";
import NoImageSVG from "components/SVGComponents/NoImageSVG";

const TrendingJobs = () => {
  const { projects, isLoading } = useSelector((state) => state.projects);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjects({ pageNo: 1, perPage: 5, sortBy: "LATEST" }));
  }, [dispatch]);

  return (
    <section className={styles.trendingJobs}>
      <div className={styles.trendingHeading}>
        <p>Recent Projects</p>
        <Link
          to={"/projects"}
          className={`${styles.trendingShowAll} unstyledLink`}
        >
          Show All
        </Link>
      </div>

      <div className={styles.trendingJobPosts}>
        {isLoading ? (
          <TrendingJobsSkeleton count={5} />
        ) : projects?.length > 0 ? (
          projects.map((job, index) => (
            <Link
              to={`/projects/${job?.jobId}`}
              key={index}
              className={`${styles.trendingJobPost} unstyledLink`}
            >
              <div className={styles.jobLogo}>
                {job?.companyJobRespDto?.logo ? (
                  <img
                    src={serverFiles(job?.companyJobRespDto?.logo)}
                    alt={job?.companyJobRespDto?.name || "Job Logo"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = NO_IMAGE;
                    }}
                  />
                ) : (
                  <NoImageSVG type={"profile"} height="56" width="56" />
                )}
                {/* {job?.companyJobRespDto?.logo ? (
                ) : (
                  <NoImageSVG type={"profile"} height="55" width="55" />
                )} */}
              </div>
              <div className={styles.jobDetails}>
                <p className={styles.jobTitle}>{job?.jobTitle}</p>
                <p className={styles.jobPostedBy}>
                  {job?.companyJobRespDto?.name}
                </p>
                <p className={styles.jobLocation}>{job?.cityName}</p>
              </div>
            </Link>
          ))
        ) : (
          <p className={styles.no_projects}>No Projects Found</p>
        )}
      </div>
    </section>
  );
};

export default TrendingJobs;
